// Copyright (c) Alaska Air. All right reserved. Licensed under the Apache-2.0 license
// See LICENSE in the project root for license information.

// ---------------------------------------------------------------------

import {css} from 'lit-element';
export default css`:host([fixed]) .util_insetLg--squish{padding:calc(24px / 2) 24px}:host([fixed]) .auro-button{padding:12px 24px;border-radius:6px;font-size:16px}@media screen and (min-width: 660px){:host([fixed]) .auro-button{min-width:140px}}
`;
